
import React,{Component} from 'react'
import { FacebookProvider, MessageUs } from 'react-facebook-w';
import UserActions from "lib/userActions"

export class FacebookMessenger extends Component {

    constructor(props) {
        super(props)
        this.messengerLookup = setInterval(this.setMessengerLink.bind(this),500)
        this.state = {
            drawOverlay:false,
            overlayStyle:{}
        }

        // if facebook sdk has already been initialized, we just need to ask it
        // to rerun its tests for social plugins.
        if ( typeof window !== "undefined" && window.FB ) {
            this.reinitFB = true
        }

        this.messengerClicked = this.messengerClicked.bind(this)
    }

    componentDidMount() {
        // we may need to reinit facebook sdk for social plugins.
        if ( this.reinitFB && window.fbAsyncInit ) {
            window.fbAsyncInit()
        }
    }

    setMessengerLink() {
        // lookup the iframe in the div of the plugin.
        let iframe = document.querySelector(".fb-messengermessageus iframe")
        // if it's not found yet - keep running the interval.
        if ( !iframe || !iframe.style.width.length) {
            return
        }

        // got the iframe. shut down the interval.
        clearInterval(this.messengerLookup)

        // set the style of the overlay div
        // tell state to show the overlay div.
        this.setState({
            drawOverlay:true,
            overlayStyle:{
                width:iframe.clientWidth,
                height:iframe.clientHeight,
                position:"absolute",
                zIndex:1
            }})
    }

    messengerClicked() {
        UserActions.missingDetails("Message us button clicked.", this.props.itemId)
        console.log("opening messenger")
    }

    render() {
        return <div style={{display:"inline-block"}}>
            {/* Test page link : - <a href="https://m.me/312396209466730" target="_blank">*/}
            { this.state.drawOverlay ?
                <a href="https://m.me/541950032550116" target="_blank">
                    <div id={"messenger-overlay"} style={this.state.overlayStyle} onClick={this.messengerClicked}></div>
                </a>
                 : null }
            <FacebookProvider appId={"543371519103511"} version={"v3.2"} >
                <MessageUs size={"xlarge"} messengerAppId="543371519103511" pageId="541950032550116"></MessageUs>
            </FacebookProvider>
        </div>
    }
}